import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../../App';
export const SyncFullMexPMOperations = () => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.get(
    GetBackendUrlForGlobalFunctions() +
      `mex-preventative-maintenance/sync-full`,
    {
      headers,
    }
  );
};
